const fr = {
  common: {
    actions: {
      previous: "Pr\u00e9c\u00e9dent",
      next: "Suivant",
      showPrevious: "Afficher les \u00e9l\u00e9ments pr\u00e9c\u00e9dents",
      showNext: "Afficher les \u00e9l\u00e9ments suivants",
      openMenu: "Ouvrir le menu de navigation",
      changeLanguage: "Changer de langue",
    },
    labels: {
      language: "Langue",
    },
    cta: {
      contact: "Contactez-nous",
      learnMore: "En savoir plus",
      exploreApproach: "D\u00e9couvrir notre approche",
      submit: "Envoyer",
    },
    forms: {
      firstName: "Pr\u00e9nom",
      lastName: "Nom",
      email: "E-mail",
      phoneNumber: "Num\u00e9ro de t\u00e9l\u00e9phone",
      message: "Message",
      emailPlaceholder: "vous@entreprise.com",
      phonePlaceholder: "+244 000 000 000",
      intlPhonePlaceholder: "+1 (555) 000-0000",
      messagePlaceholder: "Laissez-nous un message...",
      validation: {
        firstNameRequired: "Le pr\u00e9nom est requis.",
        lastNameRequired: "Le nom est requis.",
        emailRequired: "L'e-mail est requis.",
        invalidEmail: "Veuillez saisir une adresse e-mail valide.",
        phoneRequired: "Le num\u00e9ro de t\u00e9l\u00e9phone est requis.",
        invalidPhone: "Veuillez saisir un num\u00e9ro de t\u00e9l\u00e9phone valide.",
        messageRequired: "Le message est requis.",
      },
    },
    feedback: {
      sending: "Envoi...",
      messageSent: "Votre message a \u00e9t\u00e9 envoy\u00e9 avec succ\u00e8s.",
      somethingWrong: "Une erreur s'est produite. Veuillez r\u00e9essayer.",
      serverError: "Erreur du serveur. Veuillez r\u00e9essayer plus tard.",
    },
    siteCta: {
      title: "Votre partenaire strat\u00e9gique pour transformer l'Angola",
      text: "Nous travaillons avec les gouvernements, les investisseurs et les institutions pour d\u00e9bloquer des opportunit\u00e9s strat\u00e9giques et soutenir une transformation \u00e9conomique durable en Angola.",
    },
    company: {
      shortDescription: "Nous travaillons avec les gouvernements, les investisseurs et les institutions pour d\u00e9bloquer des opportunit\u00e9s strat\u00e9giques et soutenir une transformation \u00e9conomique durable en Angola.",
      locationLuanda: "Rua Frederico Welwitschia Torre Maculusso, 5e \u00e9tage Luanda, Angola",
      locationCapeTown: "The Estuaries, Building 12 Century City Cape Town, 7441",
    },
    footer: {
      quickLinks: "Liens rapides",
      servicesTitle: "Nos services",
      phoneLabel: "T\u00e9l\u00e9phone :",
      copyright: "\u00a9 2027 Provest Capital Management. Tous droits r\u00e9serv\u00e9s.",
      links: {
        home: "Accueil",
        about: "\u00c0 propos",
        services: "Services",
        newsroom: "Actualit\u00e9s",
        contact: "Contactez-nous",
      },
      services: [
        "Travaux publics et civils",
        "Projets r\u00e9sidentiels",
        "Infrastructures industrielles",
        "R\u00e9habilitation et r\u00e9novation",
        "Gestion et supervision de projet",
      ],
      legal: {
        privacy: "Politique de confidentialit\u00e9",
        terms: "Conditions g\u00e9n\u00e9rales",
      },
    },
  },
  header: {
    nav: {
      home: "Accueil",
      about: "\u00c0 propos",
      ourPosition: "Notre positionnement",
      esg: "ESG",
      contact: "Contactez-nous",
      solutions: "Solutions",
      privateSector: "Secteur priv\u00e9",
      publicSector: "Secteur public",
    },
  },
  pages: {
    home: {
      hero: {
        title: "Strat\u00e9gie et r\u00e9solution de probl\u00e8mes pour des projets \u00e0 fort impact",
      },
      moment: {
        title: "L'Angola \u00e0 un moment d\u00e9cisif",
        subtitle: "Le potentiel de diversification est immense, mais la complexit\u00e9 exige plus que du capital : elle exige de la m\u00e9thode et de l'ex\u00e9cution.",
        cards: [
          {
            title: "Diversification \u00e9conomique",
            text: "Transition urgente d'une \u00e9conomie d\u00e9pendante du p\u00e9trole vers des secteurs productifs et diversifi\u00e9s. Construire des bases \u00e9conomiques durables.",
          },
          {
            title: "Capital intelligent",
            text: "Structuration financi\u00e8re sophistiqu\u00e9e pour permettre des projets de long terme. Des investissements strat\u00e9giques qui cr\u00e9ent une valeur durable.",
          },
          {
            title: "Ex\u00e9cution disciplin\u00e9e",
            text: "Capacit\u00e9 \u00e0 naviguer dans le contexte op\u00e9rationnel et \u00e0 assurer une mise en \u0153uvre efficace. Cadres solides de gouvernance et de redevabilit\u00e9.",
          },
        ],
      },
      positioning: {
        title: "Notre positionnement",
        subtitle: "Strat\u00e9gie + r\u00e9solution de probl\u00e8mes : une pens\u00e9e strat\u00e9gique solide alli\u00e9e \u00e0 une vraie capacit\u00e9 d'ex\u00e9cution",
        strategyTitle: "Strat\u00e9gie",
        strategyText: "Analyse strat\u00e9gique approfondie du contexte \u00e9conomique, institutionnel et sectoriel afin de :",
        strategyPoints: [
          "Clarifier les priorit\u00e9s critiques de chaque projet",
          "Identifier de v\u00e9ritables opportunit\u00e9s de cr\u00e9ation de valeur",
          "Concevoir des solutions structur\u00e9es qui soutiennent des d\u00e9cisions d'investissement \u00e9clair\u00e9es",
        ],
        problemTitle: "R\u00e9solution de probl\u00e8mes",
        problemText: "Accompagnement pratique de la mise en \u0153uvre, en g\u00e9rant la complexit\u00e9 r\u00e9elle des projets :",
        problemPoints: [
          "Surmonter les obstacles institutionnels et op\u00e9rationnels",
          "Coordination efficace entre les parties prenantes",
          "Assurer une ex\u00e9cution disciplin\u00e9e de la structuration \u00e0 l'exploitation",
        ],
      },
      who: {
        title: "Qui nous sommes",
        subtitle: "Une entreprise angolaise sp\u00e9cialis\u00e9e dans la structuration de projets, la gestion strat\u00e9gique et la mobilisation de capitaux.",
        missionTitle: "Notre mission",
        missionText: "Accompagner les entreprises et les institutions dans la cr\u00e9ation de valeur durable et l'acc\u00e8s \u00e0 des capitaux strat\u00e9giques, gr\u00e2ce \u00e0 une approche fond\u00e9e sur la transparence, le professionnalisme et la responsabilit\u00e9.",
        visionTitle: "Notre vision",
        visionText: "Devenir un partenaire de r\u00e9f\u00e9rence pour la mobilisation de capitaux au service de projets structur\u00e9s qui dynamisent l'\u00e9conomie r\u00e9elle de l'Angola, gr\u00e2ce \u00e0 un alignement durable entre strat\u00e9gie, capital et ex\u00e9cution.",
      },
      operating: {
        title: "Notre mani\u00e8re d'op\u00e9rer",
        subtitle: "Nous intervenons l\u00e0 o\u00f9 convergent la strat\u00e9gie, le capital et l'ex\u00e9cution.",
        cards: [
          {
            id: "01",
            title: "Strat\u00e9gie et mod\u00e9lisation",
            points: [
              "D\u00e9finition de l'orientation strat\u00e9gique et de la viabilit\u00e9 \u00e9conomique",
              "Gestion rigoureuse des risques pour soutenir des d\u00e9cisions d'investissement \u00e9clair\u00e9es",
            ],
          },
          {
            id: "02",
            title: "Structuration et capital",
            points: [
              "Structuration financi\u00e8re et mobilisation de capitaux avec les banques et les fonds",
              "Mod\u00e9lisation financi\u00e8re align\u00e9e sur l'\u00e9chelle du projet et son profil de risque",
            ],
          },
          {
            id: "03",
            title: "Partenariats techniques",
            points: [
              "S\u00e9lection et int\u00e9gration de partenaires techniques et op\u00e9rationnels de premier plan",
              "Transfert efficace du savoir-faire et des meilleures pratiques",
            ],
          },
          {
            id: "04",
            title: "Ex\u00e9cution et pilotage",
            points: [
              "Suivi continu et coordination institutionnelle",
              "Alignement complet entre strat\u00e9gie, capital et ex\u00e9cution",
            ],
          },
        ],
      },
      solutions: {
        title: "Nos solutions",
        subtitle: "Nous d\u00e9ployons des strat\u00e9gies sur mesure dans diff\u00e9rents secteurs pour favoriser une croissance durable et un avantage concurrentiel.",
        items: [
          {
            title: "Secteur priv\u00e9",
            desc: "Des solutions strat\u00e9giques et orient\u00e9es ex\u00e9cution qui aident les entreprises \u00e0 se d\u00e9velopper, \u00e0 optimiser leurs performances et \u00e0 atteindre une croissance durable sur des march\u00e9s concurrentiels.",
          },
          {
            title: "Secteur public",
            desc: "Un accompagnement en conseil et en mise en \u0153uvre pour aider les gouvernements et les institutions \u00e0 d\u00e9velopper des projets \u00e0 fort impact, renforcer les infrastructures et stimuler un progr\u00e8s \u00e9conomique durable.",
          },
        ],
      },
      esg: {
        title: "L'ESG comme levier d'ex\u00e9cution",
        subtitle: "Int\u00e9grer les principes environnementaux, sociaux et de gouvernance dans l'ex\u00e9cution des projets afin d'assurer une durabilit\u00e9 \u00e0 long terme et un d\u00e9veloppement responsable.",
        items: [
          {
            title: "Responsabilit\u00e9 environnementale",
            desc: "Engagement envers des pratiques respectueuses de l'environnement.",
          },
          {
            title: "Impact social",
            desc: "Des projets con\u00e7us pour g\u00e9n\u00e9rer des b\u00e9n\u00e9fices sociaux concrets.",
          },
          {
            title: "Transparence de gouvernance",
            desc: "Des normes de gouvernance solides garantissant la redevabilit\u00e9.",
          },
          {
            title: "Cadres d'investissement durable",
            desc: "Des strat\u00e9gies d'investissement align\u00e9es sur les principes de durabilit\u00e9.",
          },
        ],
      },
    },
    about: {
      hero: {
        title: "Con\u00e7us pour le moment d\u00e9cisif de l'Angola",
        text: "Une entreprise n\u00e9e de la conviction que le potentiel de l'Angola exige plus que de l'ambition. Il exige de la strat\u00e9gie, de la discipline et une ex\u00e9cution ancr\u00e9e dans une connaissance locale approfondie.",
      },
      stats: [
        { value: "10+", label: "Ann\u00e9es d'expertise" },
        { value: "40+", label: "Projets r\u00e9alis\u00e9s" },
        { value: "$2B+", label: "Capital structur\u00e9" },
        { value: "12", label: "Secteurs couverts" },
        { value: "5", label: "Pays d'op\u00e9ration" },
      ],
      story: {
        badgeLabel: "MEMBRE DE",
        badgeTitle: "PROVEST HOLDING",
        badgeText: "Bas\u00e9 en Afrique du Sud",
        title: "B\u00e2tis \u00e0 l'intersection de la strat\u00e9gie, du capital et de l'ex\u00e9cution",
        paragraphOne: "PRO-VEST Capital Management est une entreprise angolaise sp\u00e9cialis\u00e9e dans la structuration de projets, la gestion strat\u00e9gique et la mobilisation de capitaux, combinant la discipline de la finance internationale avec une intelligence approfondie du march\u00e9 local.",
        paragraphTwo: "Nous faisons partie de PROVEST Holding, bas\u00e9e en Afrique du Sud, ce qui renforce notre capacit\u00e9 \u00e0 ex\u00e9cuter des projets de l'\u00e9conomie r\u00e9elle en Angola en apportant une structure d'entreprise internationale et des capacit\u00e9s mondiales \u00e0 l'ex\u00e9cution locale.",
        quote: "Nous ne faisons pas que conseiller. Nous structurons, capitalisons et ex\u00e9cutons en restant responsables tout au long du cycle de vie du projet.",
      },
      pillars: {
        title: "Trois piliers de notre approche",
        text: "Chaque mission repose sur l'intersection entre intelligence du capital, rigueur op\u00e9rationnelle et int\u00e9grit\u00e9 de gouvernance.",
        items: [
          {
            id: "01",
            title: "Intelligence strat\u00e9gique du capital",
            description: "Nous identifions o\u00f9 le capital intelligent cr\u00e9e des effets multiplicateurs, et pas seulement du rendement. Une structuration financi\u00e8re align\u00e9e sur les r\u00e9alit\u00e9s macro\u00e9conomiques de l'Angola et ses objectifs de d\u00e9veloppement \u00e0 long terme.",
            tags: ["Structuration du capital", "Mod\u00e9lisation des risques", "Strat\u00e9gie d'investissement"],
          },
          {
            id: "02",
            title: "Ex\u00e9cution op\u00e9rationnelle",
            description: "Une strat\u00e9gie sans ex\u00e9cution est une fiction. Nous restons pr\u00e9sents de la conception \u00e0 l'ach\u00e8vement, en naviguant dans l'environnement op\u00e9rationnel angolais avec discipline et responsabilit\u00e9.",
            tags: ["Gestion de projet", "Support PMO", "Suivi KPI"],
          },
          {
            id: "03",
            title: "Gouvernance et transparence",
            description: "La confiance est notre mode op\u00e9ratoire. Chaque structure que nous concevons int\u00e8gre la transparence, la redevabilit\u00e9 et les principes d'investissement responsable pour cr\u00e9er une valeur durable pour toutes les parties prenantes.",
            tags: ["Int\u00e9gration ESG", "Conformit\u00e9", "Reporting"],
          },
        ],
      },
      who: {
        title: "Qui nous sommes",
        subtitle: "Une entreprise angolaise sp\u00e9cialis\u00e9e dans la structuration de projets, la gestion strat\u00e9gique et la mobilisation de capitaux.",
        missionTitle: "Notre mission",
        missionText: "Accompagner les entreprises et les institutions dans la cr\u00e9ation de valeur durable et l'acc\u00e8s \u00e0 des capitaux strat\u00e9giques, gr\u00e2ce \u00e0 une approche fond\u00e9e sur la transparence, le professionnalisme et la responsabilit\u00e9.",
        visionTitle: "Notre vision",
        visionText: "Devenir un partenaire de r\u00e9f\u00e9rence pour la mobilisation de capitaux au service de projets structur\u00e9s qui dynamisent l'\u00e9conomie r\u00e9elle de l'Angola, gr\u00e2ce \u00e0 un alignement durable entre strat\u00e9gie, capital et ex\u00e9cution.",
      },
      values: {
        title: "Des valeurs qui guident chaque d\u00e9cision",
        text: "Fond\u00e9es sur des principes solides, nos valeurs fa\u00e7onnent notre culture et nourrissent une excellence constante pour offrir des solutions fiables, impactantes et tourn\u00e9es vers l'avenir.",
        items: [
          {
            title: "Responsabilit\u00e9 sans compromis",
            description: "Nous sommes jug\u00e9s sur les r\u00e9sultats, pas sur l'effort. Chaque projet que nous menons s'accompagne d'une structure claire de responsabilit\u00e9 et nous nous l'imposons avant de l'exiger des autres.",
            featured: true,
          },
          {
            title: "L'int\u00e9grit\u00e9 comme mod\u00e8le \u00e9conomique",
            description: "La transparence n'est pas seulement une exigence de conformit\u00e9. C'est un avantage concurrentiel. Notre r\u00e9putation est notre actif le plus durable.",
          },
          {
            title: "Local d'abord, standard mondial",
            description: "Nous op\u00e9rons avec l'intimit\u00e9 d'un partenaire local et la rigueur d'une institution internationale.",
          },
          {
            title: "Vision de long terme",
            description: "Nous optimisons la cr\u00e9ation de valeur sur plusieurs d\u00e9cennies, et non sur des r\u00e9sultats trimestriels. La transformation de l'Angola est g\u00e9n\u00e9rationnelle.",
          },
          {
            title: "Innovation disciplin\u00e9e",
            description: "Nous apportons des id\u00e9es nouvelles \u00e0 d'anciens probl\u00e8mes, toujours ancr\u00e9es dans la preuve, la faisabilit\u00e9 et les r\u00e9alit\u00e9s de l'ex\u00e9cution sur le terrain.",
          },
        ],
      },
      document: {
        title: "Certificat provisoire d'enregistrement ANPG",
        text: "Consultez le certificat provisoire d'enregistrement de PVMT-PROVEST Capital Management pour le secteur pétrolier et gazier en Angola, délivré par l'Agence nationale du pétrole, du gaz et des biocarburants.",
        fallback: "Ce navigateur ne peut pas afficher le PDF directement.",
        open: "Ouvrir le PDF",
      },
    },
    ourPosition: {
      hero: {
        title: "Une pens\u00e9e strat\u00e9gique solide alli\u00e9e \u00e0 une v\u00e9ritable capacit\u00e9 d'ex\u00e9cution",
        text: "Nous nous situons \u00e0 l'intersection de la strat\u00e9gie et de l'ex\u00e9cution, non pas comme des conseillers qui partent apr\u00e8s la pr\u00e9sentation, mais comme des partenaires qui restent dans la complexit\u00e9 et livrent des r\u00e9sultats mesurables.",
      },
      positioning: {
        title: "Notre positionnement",
        text: "Strat\u00e9gie + r\u00e9solution de probl\u00e8mes : une pens\u00e9e strat\u00e9gique solide alli\u00e9e \u00e0 une vraie capacit\u00e9 d'ex\u00e9cution",
        keyCapabilities: "Capacit\u00e9s cl\u00e9s",
        sections: [
          {
            eyebrow: "Strat\u00e9gie",
            title: "Une planification strat\u00e9gique approfondie pour de meilleurs r\u00e9sultats.",
            description: "Nous analysons la dynamique des march\u00e9s, le contexte institutionnel et les objectifs des projets afin de construire une base solide pour la r\u00e9ussite.",
            capabilities: [
              "Identifier les priorit\u00e9s cl\u00e9s et les opportunit\u00e9s de croissance",
              "Aligner la strat\u00e9gie avec les objectifs financiers et commerciaux",
              "\u00c9laborer des plans d'ex\u00e9cution structur\u00e9s et fond\u00e9s sur les donn\u00e9es",
              "Permettre une prise de d\u00e9cision \u00e9clair\u00e9e et confiante",
            ],
          },
          {
            eyebrow: "R\u00e9solution de probl\u00e8mes",
            title: "Des solutions concr\u00e8tes qui transforment les d\u00e9fis en progr\u00e8s.",
            description: "Nous apportons un accompagnement pratique pour g\u00e9rer la complexit\u00e9 et assurer une ex\u00e9cution fluide de la planification \u00e0 la livraison.",
            capabilities: [
              "Surmonter les d\u00e9fis op\u00e9rationnels et structurels",
              "Aligner les parties prenantes et fluidifier les processus",
              "Piloter une ex\u00e9cution efficace avec une responsabilit\u00e9 claire",
              "Assurer la coh\u00e9rence de la strat\u00e9gie \u00e0 la mise en \u0153uvre",
            ],
          },
        ],
      },
      convergence: {
        title: "L\u00e0 o\u00f9 convergent la strat\u00e9gie, le capital et l'ex\u00e9cution",
        text: "Nous intervenons \u00e0 la convergence de trois forces : la clart\u00e9 strat\u00e9gique, le capital intelligent et l'ex\u00e9cution disciplin\u00e9e pour produire des r\u00e9sultats dans l'\u00e9conomie r\u00e9elle.",
        techStrip: "Technologie et intelligence des donn\u00e9es : une analyse des risques plus intelligente gr\u00e2ce \u00e0 des informations pilot\u00e9es par l'IA.",
        cards: [
          {
            id: "01",
            title: "Strat\u00e9gie et mod\u00e9lisation",
            description: "Relie la strat\u00e9gie, l'analyse et la prise de d\u00e9cision. Une analyse rigoureuse des risques pour soutenir le meilleur choix d'investissement et la cr\u00e9ation de valeur \u00e0 long terme pour toutes les parties prenantes.",
          },
          {
            id: "02",
            title: "Structuration et capital",
            description: "Une structuration qui permet l'acc\u00e8s au capital avec les partenaires et les investisseurs. Une mod\u00e9lisation financi\u00e8re align\u00e9e sur l'\u00e9chelle du projet, son profil de risque et sa durabilit\u00e9 \u00e0 long terme.",
          },
          {
            id: "03",
            title: "Partenariats techniques",
            description: "S\u00e9lectionner et int\u00e9grer des partenaires techniques de premier plan pour acc\u00e9der au capital strat\u00e9gique, gr\u00e2ce \u00e0 une approche ancr\u00e9e dans les meilleures pratiques internationales et la connaissance locale.",
          },
          {
            id: "04",
            title: "Ex\u00e9cution et pilotage",
            description: "Suivi continu et coordination institutionnelle. Alignement complet entre strat\u00e9gie, capital et ex\u00e9cution tout au long de l'op\u00e9ration, du premier tirage \u00e0 la livraison finale.",
          },
        ],
      },
      differentiators: {
        title: "Nos diff\u00e9renciateurs concurrentiels",
        text: "Cinq raisons pour lesquelles PRO-VEST est le bon partenaire strat\u00e9gique pour les projets complexes en Angola. Survolez chaque ligne pour explorer.",
        items: [
          {
            id: "01",
            title: "Execution-first, always",
            description: "Nous ne sommes pas un cabinet de conseil qui dispara\u00eet apr\u00e8s la pr\u00e9sentation. Nous restons au c\u0153ur de la complexit\u00e9, de la structuration \u00e0 l'exploitation, en gardant une responsabilit\u00e9 totale sur les r\u00e9sultats. Notre mod\u00e8le \u00e9conomique repose sur la livraison, pas sur le conseil.",
            badge: "Atout cl\u00e9",
          },
          {
            id: "02",
            title: "Local intelligence",
            description: "Une connaissance approfondie du march\u00e9 angolais qui ne peut pas \u00eatre reproduite par des acteurs op\u00e9rant de l'ext\u00e9rieur. Nous connaissons les institutions, les dynamiques et le chemin \u00e0 travers la complexit\u00e9. L'intelligence locale est notre principal avantage concurrentiel.",
            badge: "March\u00e9",
          },
          {
            id: "03",
            title: "International standards",
            description: "Soutenus par PROVEST Holding en Afrique du Sud, nous apportons une structure d'entreprise internationale et un r\u00e9seau mondial qui hissent chaque mission aux standards internationaux de rigueur et de gouvernance. Ex\u00e9cution locale, standards mondiaux.",
            badge: "R\u00e9seau",
          },
          {
            id: "04",
            title: "ESG as an edge",
            description: "Nous int\u00e9grons les principes environnementaux, sociaux et de gouvernance dans la conception des projets non comme une contrainte de conformit\u00e9, mais comme un levier strat\u00e9gique qui attire de meilleurs capitaux, de meilleurs partenaires et des r\u00e9sultats plus durables pour chaque partie prenante.",
            badge: "Durabilit\u00e9",
          },
          {
            id: "05",
            title: "Proven track record",
            description: "Plus de 2 milliards de dollars structur\u00e9s, plus de 40 projets ex\u00e9cut\u00e9s et une d\u00e9cennie de cr\u00e9dibilit\u00e9 construite avec les gouvernements, les institutions et les investisseurs internationaux en Angola et dans la r\u00e9gion. Les chiffres parlent d'eux-m\u00eames.",
            badge: "R\u00e9f\u00e9rences",
          },
        ],
      },
      stats: [
        { value: "10+", label: "Ann\u00e9es d'action dans l'\u00e9conomie r\u00e9elle de l'Angola" },
        { value: "40+", label: "Projets ex\u00e9cut\u00e9s dans les secteurs priv\u00e9 et public" },
        { value: "$2B+", label: "Capital structur\u00e9 sur l'ensemble des projets" },
        { value: "5", label: "Pays d'op\u00e9ration active" },
      ],
    },
    esg: {
      hero: {
        title: "L'ESG comme levier d'ex\u00e9cution",
        text: "Nous int\u00e9grons les principes environnementaux, sociaux et de gouvernance dans la conception et la mise en \u0153uvre des projets afin de garantir une durabilit\u00e9 \u00e0 long terme et un d\u00e9veloppement responsable.",
        pillarsLabel: "Piliers ESG",
        pillars: [
          { key: "E", label: "Environnement" },
          { key: "S", label: "Social" },
          { key: "G", label: "Gouvernance" },
        ],
      },
      stats: [
        { value: "100%", label: "Projets avec cadre ESG" },
        { value: "3", label: "Piliers ESG int\u00e9gr\u00e9s" },
        { value: "10+", label: "Ann\u00e9es d'investissement responsable" },
        { value: "4", label: "Pays couverts" },
      ],
      intro: {
        kicker: "L'ESG comme levier d'ex\u00e9cution",
        title: "Nous intégrons l’ESG dans chaque projet et chaque décision.",
        caption: "À une époque où les marchés exigent à la fois performance et responsabilité, l’ESG n’est pas pour nous une simple case à cocher dans un rapport — c’est un levier stratégique qui façonne la manière dont le capital est déployé, dont les projets sont structurés et dont les résultats sont obtenus. Nous intégrons les principes environnementaux, sociaux et de gouvernance dès les premières étapes de la planification jusqu’à l’exécution et au suivi, en veillant à ce que chaque décision soit alignée sur une création de valeur à long terme.",
        caption1: "En intégrant l’ESG dans nos processus fondamentaux, nous renforçons la gestion des risques, améliorons la transparence et instaurons la confiance avec les parties prenantes. Cette approche nous permet de favoriser des investissements plus résilients, de développer des partenariats plus solides et de livrer des projets qui sont non seulement commercialement viables, mais aussi socialement responsables et écologiquement durables.",
        paragraphs: [
          "Le moment d\u00e9cisif de l'Angola exige un capital non seulement intelligent mais responsable. Pour nous, l'ESG n'est pas une case de reporting. C'est un levier strat\u00e9gique qui d\u00e9bloque des capitaux, renforce les partenariats et am\u00e9liore les r\u00e9sultats des projets.",
          "Nous int\u00e9grons les principes environnementaux, sociaux et de gouvernance dans la conception et la mise en \u0153uvre des projets, assurant une durabilit\u00e9 \u00e0 long terme et un d\u00e9veloppement responsable dans l'ensemble de nos mandats.",
        ],
        quote: "L'ESG comme levier d'ex\u00e9cution signifie int\u00e9grer les principes environnementaux, sociaux et de gouvernance dans l'ex\u00e9cution des projets afin d'assurer une durabilit\u00e9 \u00e0 long terme.",
      },
      environmental: {
        title: "Responsabilit\u00e9 environnementale",
        text: "Engag\u00e9s pour des pratiques respectueuses de l'environnement dans chaque projet que nous structurons et ex\u00e9cutons en Angola et dans la r\u00e9gion.",
        badgeLabel: "Environnement - E",
        badgeText: "Projets avec \u00e9valuation d'impact environnemental",
        items: [
          {
            title: "\u00c9valuation de l'impact environnemental",
            description: "Chaque projet comprend un examen environnemental complet avant le d\u00e9but de la structuration, couvrant les risques, les mesures d'att\u00e9nuation et les indicateurs de durabilit\u00e9 \u00e0 long terme.",
          },
          {
            title: "Int\u00e9gration de pratiques responsables",
            description: "Nous alignons les projets sur des pratiques respectueuses de l'environnement afin que leur mise en \u0153uvre contribue positivement \u00e0 l'environnement naturel de l'Angola et aux standards internationaux.",
          },
          {
            title: "Capital align\u00e9 sur le climat",
            description: "Le capital est orient\u00e9 vers des projets qui soutiennent la r\u00e9silience, la diversification et des objectifs mesurables de transition environnementale.",
          },
        ],
      },
      social: {
        title: "Impact social",
        text: "Des projets con\u00e7us pour g\u00e9n\u00e9rer des b\u00e9n\u00e9fices sociaux concrets par l'emploi, la r\u00e9silience et une participation locale renforc\u00e9e.",
        panelLabel: "Impact social - S",
        panelTitle: "La communaut\u00e9 d'abord",
        panelText: "Chaque projet est \u00e9valu\u00e9 selon son retour social",
        items: [
          {
            title: "Cr\u00e9ation d'emplois",
            description: "Chaque projet que nous structurons est \u00e9valu\u00e9 pour sa contribution directe et indirecte \u00e0 l'emploi, en priorisant des postes significatifs et durables pour les travailleurs angolais.",
          },
          {
            title: "R\u00e9silience communautaire",
            description: "Nous soutenons des projets qui renforcent les capacit\u00e9s locales, am\u00e9liorent l'acc\u00e8s aux services et r\u00e9duisent la vuln\u00e9rabilit\u00e9 gr\u00e2ce \u00e0 des r\u00e9sultats concrets pour les communaut\u00e9s.",
          },
          {
            title: "Am\u00e9lioration des moyens de subsistance",
            description: "Au-del\u00e0 des infrastructures, nous recherchons des b\u00e9n\u00e9fices sociaux mesurables via l'acc\u00e8s aux opportunit\u00e9s \u00e9conomiques, aux services essentiels et \u00e0 une inclusion durable.",
          },
        ],
      },
      governance: {
        title: "Transparence de gouvernance",
        text: "Des standards de gouvernance solides assurent la redevabilit\u00e9, la transparence du reporting et un comportement institutionnel responsable.",
        items: [
          {
            title: "Normes de transparence",
            description: "Des standards de gouvernance solides assurent la redevabilit\u00e9 sur tous les mandats, avec des dispositifs de reporting et de divulgation int\u00e9gr\u00e9s d\u00e8s la structuration du projet.",
          },
          {
            title: "Cadres de conformit\u00e9",
            description: "Des cadres complets de conformit\u00e9 s'alignent sur les standards internationaux de gouvernance afin que chaque projet r\u00e9ponde aux exigences des investisseurs et des institutions de financement du d\u00e9veloppement.",
          },
          {
            title: "Structures de responsabilit\u00e9",
            description: "Des structures claires de responsabilit\u00e9 prot\u00e8gent les int\u00e9r\u00eats des investisseurs, des gouvernements, des communaut\u00e9s et des op\u00e9rateurs tout au long du cycle d'ex\u00e9cution.",
          },
        ],
      },
    },
    contact: {
      hero: {
        title: "Entrez en contact avec nos experts",
        text: "Chaque projet commence par une conversation. Discutons de votre vision et traduisons-la en une solution pratique et \u00e0 fort impact.",
      },
      intro: {
        eyebrow: "Nous contacter",
        title: "Construisons quelque chose d'impactant",
        text: "Que vous structuriez un investissement, recherchiez un conseil public ou exploriez la mani\u00e8re dont PRO-VEST peut devenir votre partenaire en Angola, nous souhaitons vous entendre.",
      },
      contactItems: [
        {
          title: "T\u00e9l\u00e9phone",
          primary: "+244 938 888 888",
          secondary: "+244 961 765 500",
        },
        {
          title: "E-mail",
          primary: "info@provest.co.ao",
          secondary: "Nous r\u00e9pondons sous 24 heures",
        },
        {
          title: "LinkedIn",
          primary: "PRO-VEST Capital Management",
          secondary: "Connectez-vous avec notre \u00e9quipe",
        },
      ],
      locations: {
        eyebrow: "Nos implantations",
        title: "L\u00e0 o\u00f9 nous op\u00e9rons",
        text: "Implant\u00e9s de mani\u00e8re permanente en Angola avec une pr\u00e9sence en Afrique du Sud, nous ne sommes pas des conseillers \u00e0 distance mais des partenaires ancr\u00e9s dans les march\u00e9s que nous servons.",
        items: [
          {
            id: "ao",
            tab: "AO Luanda, Angola",
            title: "Luanda, Angola - Bureau principal",
            address: "Rua Frederico Welwitschia, Torre Maculusso 5e \u00e9tage - Luanda, Angola",
            mapTitle: "Carte du bureau de Luanda",
          },
          {
            id: "za",
            tab: "ZA Le Cap, AFS",
            title: "Le Cap, Afrique du Sud - PROVEST Holding",
            address: "The Estuaries, Building 12, Century City Cape Town, 7441",
            mapTitle: "Carte du bureau du Cap",
          },
        ],
      },
    },
    privateSector: {
      hero: {
        title: "Solutions pour le secteur priv\u00e9",
        text: "Des solutions strat\u00e9giques et orient\u00e9es ex\u00e9cution qui aident les entreprises \u00e0 se d\u00e9velopper, optimiser leur performance et atteindre une croissance durable sur des march\u00e9s concurrentiels.",
        chipsLabel: "Domaines d'intervention du secteur priv\u00e9",
        chips: ["Investissement et expansion", "M&A et capital"],
      },
      expansion: {
        title: "Investissement et expansion",
        text: "Des projets port\u00e9s par la croissance et de nouveaux investissements, des opportunit\u00e9s greenfield \u00e0 la transformation compl\u00e8te de l'entreprise.",
        cards: [
          {
            eyebrow: "Investissements",
            title: "Projets greenfield et nouveaux investissements",
            description: "Nous identifions, structurons et ex\u00e9cutons des opportunit\u00e9s d'investissement greenfield, de la faisabilit\u00e9 financi\u00e8re jusqu'\u00e0 la livraison du projet. Notre \u00e9quipe rassemble le capital, les partenaires et les capacit\u00e9s d'ex\u00e9cution n\u00e9cessaires pour transformer des opportunit\u00e9s en actifs op\u00e9rationnels.",
            tags: ["Viabilit\u00e9", "Structuration", "Ex\u00e9cution"],
          },
          {
            eyebrow: "Structure",
            title: "Croissance, expansion et transformation d'entreprise",
            description: "Nous accompagnons les entreprises \u00e9tablies pour qu'elles changent d'\u00e9chelle, p\u00e9n\u00e8trent de nouveaux march\u00e9s ou transforment leur mod\u00e8le op\u00e9rationnel gr\u00e2ce \u00e0 du conseil strat\u00e9gique, de la structuration de capital et un accompagnement pratique allant au-del\u00e0 de la salle de conseil.",
            tags: ["Croissance", "Expansion", "Transformation"],
          },
        ],
      },
      capital: {
        title: "M&A et capital",
        text: "Fusions, acquisitions et restructuration du capital pour naviguer dans la complexit\u00e9 et cr\u00e9er de la valeur strat\u00e9gique.",
        cards: [
          {
            eyebrow: "M&A",
            title: "Fusions et acquisitions (M&A)",
            description: "Conseil en fusions et acquisitions de bout en bout \u2014 de l'identification des cibles et de la valorisation \u00e0 la n\u00e9gociation, \u00e0 la diligence raisonnable et \u00e0 la cl\u00f4ture des transactions. Nous naviguons dans l'environnement r\u00e9glementaire et institutionnel unique de l'Angola pour obtenir des r\u00e9sultats que les cabinets de conseil travaillant \u00e0 distance ne peuvent pas offrir.",
            tags: ["Valorisation", "N\u00e9gociation", "Cl\u00f4ture"],
          },
          {
            eyebrow: "Capital et finance",
            title: "Restructuration du capital et optimisation financi\u00e8re",
            description: "Repenser la structure du capital des entreprises pour lib\u00e9rer la croissance, r\u00e9duire le risque financier et attirer de nouveaux investissements \u2014 gr\u00e2ce \u00e0 la restructuration des fonds propres, au refinancement de la dette et \u00e0 une mod\u00e9lisation financi\u00e8re align\u00e9e sur les objectifs strat\u00e9giques de l'entreprise et les r\u00e9alit\u00e9s du march\u00e9 des capitaux angolais.",
            tags: ["Restructuration", "Mod\u00e9lisation financi\u00e8re", "Optimisation"],
          },
        ],
      },
      disciplines: {
        title: "L\u00e0 o\u00f9 la strat\u00e9gie rencontre quatre disciplines",
        text: "De la planification strat\u00e9gique \u00e0 l'ex\u00e9cution, nos capacit\u00e9s int\u00e9gr\u00e9es assurent clart\u00e9, efficacit\u00e9 et succ\u00e8s \u00e0 long terme pour chaque projet.",
        items: [
          {
            number: "01",
            title: "Strat\u00e9gie",
            description: "Analyse les tendances strat\u00e9giques du contexte \u00e9conomique et institutionnel afin de clarifier les priorit\u00e9s et de produire de vraies d\u00e9cisions d'investissement.",
          },
          {
            number: "02",
            title: "Structuration financi\u00e8re",
            description: "Concevoir la bonne structure de capital align\u00e9e sur l'\u00e9chelle du projet, son profil de risque et les exigences des investisseurs, de la faisabilit\u00e9 \u00e0 la bancabilit\u00e9.",
          },
          {
            number: "03",
            title: "Les bons partenaires",
            description: "S\u00e9lectionner et int\u00e9grer les bons partenaires techniques, commerciaux et institutionnels au moyen d'une m\u00e9thodologie de s\u00e9lection conforme aux meilleures pratiques.",
          },
          {
            number: "04",
            title: "Discipline d'ex\u00e9cution",
            description: "Suivi continu, coordination institutionnelle et alignement complet entre strat\u00e9gie, capital et ex\u00e9cution tout au long de l'op\u00e9ration.",
          },
        ],
      },
      contact: {
        title: "Transformez vos id\u00e9es en r\u00e9sultats",
        text: "Du concept \u00e0 l'ex\u00e9cution, nous aidons les entreprises \u00e0 g\u00e9n\u00e9rer un impact concret gr\u00e2ce \u00e0 des solutions sur mesure et performantes.",
      },
      cta: {
        title: "Pr\u00eat \u00e0 faire cro\u00eetre votre activit\u00e9 dans le secteur priv\u00e9 ?",
        text: "Que vous lanciez un investissement greenfield, poursuiviez une acquisition ou restructuriez votre activit\u00e9 pour la croissance, notre \u00e9quipe est pr\u00eate \u00e0 structurer et ex\u00e9cuter.",
      },
    },
    publicSector: {
      hero: {
        title: "Solutions pour le secteur public",
        text: "Un accompagnement en conseil et en repr\u00e9sentation pour aider les gouvernements et les institutions \u00e0 d\u00e9velopper des projets \u00e0 impact, renforcer les infrastructures et stimuler le progr\u00e8s \u00e9conomique \u00e0 long terme.",
        chipsLabel: "Domaines d'intervention du secteur public",
        chips: ["Structuration de projets", "PPP et mod\u00e8les de concession"],
      },
      projects: {
        title: "Structuration de projets",
        text: "Des projets de d\u00e9veloppement \u00e9conomique \u00e0 grande \u00e9chelle qui transforment des priorit\u00e9s publiques complexes en programmes bancables et ex\u00e9cutables.",
        cards: [
          {
            eyebrow: "D\u00c9VELOPPEMENT",
            title: "Projets de d\u00e9veloppement \u00e9conomique \u00e0 grande \u00e9chelle",
            description: "Nous structurons des programmes d'investissement \u00e0 grande \u00e9chelle pour le compte de gouvernements et d'institutions, de la faisabilit\u00e9 \u00e0 la structuration financi\u00e8re puis au suivi d'ex\u00e9cution. Notre \u00e9quipe navigue dans l'environnement institutionnel angolais pour d\u00e9bloquer des capitaux autrement inaccessibles.",
            tags: ["Planification", "Structuration", "Ex\u00e9cution"],
          },
          {
            eyebrow: "INVESTISSEMENT",
            title: "Programmes d'investissement \u00e0 impact territorial et sectoriel",
            description: "Nous concevons des programmes d'investissement qui g\u00e9n\u00e8rent un impact territorial et sectoriel, en cr\u00e9ant des infrastructures durables, de la diversification \u00e9conomique et des r\u00e9sultats de d\u00e9veloppement align\u00e9s sur les priorit\u00e9s nationales de l'Angola et les plans de d\u00e9veloppement provinciaux.",
            tags: ["Territorial", "Sectoriel", "Impact"],
          },
        ],
      },
      capital: {
        "title": "M&A et capital",
        "text": "Fusions, acquisitions et restructuration du capital pour naviguer dans la complexit\u00e9 et cr\u00e9er de la valeur strat\u00e9gique.",
        "cards": [
          {
            "eyebrow": "PPP",
            "title": "Structuration de partenariats public-priv\u00e9 (PPP)",
            "description": "Nous concevons et structurons des cadres PPP qui alignent les objectifs du secteur public avec les incitations du secteur priv\u00e9, en cr\u00e9ant des structures capables d'attirer les investisseurs institutionnels, les institutions de financement du d\u00e9veloppement et les capitaux internationaux vers les projets prioritaires de l'Angola.",
            "tags": [
              "Conception PPP",
              "Allocation des risques",
              "Structuration investisseurs"
            ]
          },
          {
            "eyebrow": "Capital et finance",
            "title": "Restructuration du capital et optimisation financi\u00e8re",
            "description": "Repenser la structure du capital des entreprises pour lib\u00e9rer la croissance, r\u00e9duire le risque financier et attirer de nouveaux investissements \u2014 gr\u00e2ce \u00e0 la restructuration des fonds propres, au refinancement de la dette et \u00e0 une mod\u00e9lisation financi\u00e8re align\u00e9e sur les objectifs strat\u00e9giques de l'entreprise et les r\u00e9alit\u00e9s du march\u00e9 des capitaux angolais.",
            "tags": [
              "PPP",
              "Risque",
              "Bancabilit\u00e9"
            ]
          }
        ]
      },
      ppp: {
        title: "PPP et mod\u00e8les de concession",
        text: "Structurer des partenariats public-priv\u00e9 qui rendent les projets publics bancables, finançables et ex\u00e9cutables.",
        cards: [
          {
            eyebrow: "PPP",
            title: "Structuration de partenariats public-priv\u00e9 (PPP)",
            description: "Nous concevons et structurons des cadres PPP qui alignent les objectifs du secteur public avec les incitations du secteur priv\u00e9, en cr\u00e9ant des structures capables d'attirer les investisseurs institutionnels, les institutions de financement du d\u00e9veloppement et les capitaux internationaux vers les projets prioritaires de l'Angola.",
            tags: ["Conception PPP", "Allocation des risques", "Structuration investisseurs"],
          },
          {
            eyebrow: "Mod\u00e8les de concession",
            title: "Mod\u00e8les de concession, partage des risques et bancabilit\u00e9",
            description: "Nous concevons des mod\u00e8les de concession qui r\u00e9partissent les risques de mani\u00e8re appropri\u00e9e entre acteurs publics et priv\u00e9s, en cr\u00e9ant des structures qui r\u00e9pondent aux exigences de bancabilit\u00e9 des pr\u00eateurs tout en prot\u00e9geant l'int\u00e9r\u00eat public et en produisant des r\u00e9sultats durables pour les communaut\u00e9s angolaises.",
            tags: ["PPP", "Risque", "Bancabilit\u00e9"],
          },
        ],
      },
      disciplines: {
        title: "Quatre piliers de l'ex\u00e9cution publique",
        text: "De la planification strat\u00e9gique \u00e0 l'ex\u00e9cution, nos capacit\u00e9s int\u00e9gr\u00e9es assurent clart\u00e9, efficacit\u00e9 et succ\u00e8s \u00e0 long terme pour chaque projet.",
      },
      contact: {
        title: "Transformez vos id\u00e9es en r\u00e9sultats",
        text: "Du concept \u00e0 l'ex\u00e9cution, nous aidons les institutions publiques \u00e0 g\u00e9n\u00e9rer un impact concret gr\u00e2ce \u00e0 des solutions sur mesure et performantes.",
      },
      cta: {
        title: "Pr\u00eat \u00e0 structurer votre prochain projet du secteur public ?",
        text: "Que vous soyez un minist\u00e8re, une institution provinciale ou une organisation multilat\u00e9rale recherchant un partenaire de confiance en Angola pour structurer et ex\u00e9cuter, nous sommes pr\u00eats.",
      },
    },
    privacy: {
      title: "Politique de confidentialit\u00e9",
      text: "Cette politique explique comment nous collectons, utilisons, prot\u00e9geons et g\u00e9rons les informations lorsque vous utilisez notre site web ou interagissez avec notre \u00e9quipe.",
      lastUpdated: "Derni\u00e8re mise \u00e0 jour : 23 avril 2026",
      lead: "PRO-VEST Capital Management respecte la vie priv\u00e9e et traite les informations avec soin. Cette page pr\u00e9sente un aper\u00e7u simple de nos pratiques g\u00e9n\u00e9rales en mati\u00e8re de confidentialit\u00e9.",
      sections: [
        {
          title: "Informations que nous collectons",
          text: "Nous pouvons collecter des coordonn\u00e9es, des informations sur l'entreprise, des demandes relatives aux projets, des correspondances et des informations techniques telles que le navigateur, l'appareil et les donn\u00e9es d'usage du site web lorsque vous interagissez avec PRO-VEST Capital Management.",
        },
        {
          title: "Comment nous utilisons les informations",
          text: "Nous utilisons les informations pour r\u00e9pondre aux demandes, \u00e9valuer les opportunit\u00e9s de collaboration, fournir des services de conseil ou li\u00e9s aux projets, am\u00e9liorer notre site web, tenir nos registres et prot\u00e9ger la s\u00e9curit\u00e9 et l'int\u00e9grit\u00e9 de nos op\u00e9rations.",
        },
        {
          title: "Partage des informations",
          text: "Nous ne vendons pas les informations personnelles. Nous pouvons partager des informations avec des conseillers professionnels de confiance, des prestataires de services, des partenaires de projet, des r\u00e9gulateurs ou des autorit\u00e9s lorsque cela est requis pour des motifs l\u00e9gitimes, juridiques, de conformit\u00e9 ou op\u00e9rationnels.",
        },
        {
          title: "Protection des donn\u00e9es",
          text: "Nous appliquons des mesures administratives, techniques et organisationnelles raisonnables destin\u00e9es \u00e0 prot\u00e9ger les informations contre tout acc\u00e8s non autoris\u00e9, perte, usage abusif ou alt\u00e9ration.",
        },
        {
          title: "Vos choix",
          text: "Vous pouvez nous contacter pour demander l'acc\u00e8s, la correction ou la suppression de vos donn\u00e9es personnelles lorsque cela est applicable. Certaines informations peuvent \u00eatre conserv\u00e9es pour des raisons juridiques, contractuelles, d'audit ou d'int\u00e9r\u00eat l\u00e9gitime de l'entreprise.",
        },
        {
          title: "Op\u00e9rations internationales",
          text: "Comme notre activit\u00e9 peut impliquer l'Angola, l'Afrique du Sud et des partenaires internationaux, les informations peuvent \u00eatre trait\u00e9es au-del\u00e0 des fronti\u00e8res lorsque cela est n\u00e9cessaire aux op\u00e9rations commerciales et \u00e0 l'ex\u00e9cution des projets.",
        },
      ],
      updatesTitle: "Contact et mises \u00e0 jour",
      updatesText: "Si vous avez des questions sur cette politique de confidentialit\u00e9, veuillez nous contacter via la page de contact. Nous pouvons mettre \u00e0 jour cette politique de temps \u00e0 autre afin de refl\u00e9ter les changements op\u00e9rationnels, juridiques ou techniques du site.",
    },
    terms: {
      title: "Conditions g\u00e9n\u00e9rales",
      text: "Ces conditions r\u00e9gissent votre acc\u00e8s \u00e0 ce site web et l'utilisation de son contenu.",
      lastUpdated: "Derni\u00e8re mise \u00e0 jour : 23 avril 2026",
      lead: "En utilisant ce site web, vous acceptez ces conditions g\u00e9n\u00e9rales. Si vous n'\u00eates pas d'accord, veuillez ne pas utiliser le site.",
      sections: [
        {
          title: "Utilisation de ce site web",
          text: "Ce site web est fourni \u00e0 titre d'information g\u00e9n\u00e9rale sur PRO-VEST Capital Management, ses capacit\u00e9s et ses domaines d'intervention. Vous acceptez d'utiliser le site de mani\u00e8re responsable et uniquement \u00e0 des fins licites.",
        },
        {
          title: "Absence de conseil professionnel",
          text: "Le contenu du site web ne constitue pas un conseil financier, juridique, fiscal, d'investissement ou professionnel. Toute mission avec PRO-VEST Capital Management fait l'objet d'accords \u00e9crits distincts et de p\u00e9rim\u00e8tres de travail convenus.",
        },
        {
          title: "Propri\u00e9t\u00e9 intellectuelle",
          text: "Tous les textes, graphismes, marques, mises en page et autres \u00e9l\u00e9ments du site appartiennent \u00e0 PRO-VEST Capital Management ou lui sont conc\u00e9d\u00e9s sous licence, sauf indication contraire. Vous ne pouvez pas copier, modifier ou r\u00e9utiliser ces \u00e9l\u00e9ments sans autorisation.",
        },
        {
          title: "Exactitude des informations",
          text: "Nous cherchons \u00e0 maintenir des informations utiles et exactes sur le site, mais nous ne garantissons pas que tout le contenu soit complet, \u00e0 jour ou exempt d'erreurs. Nous pouvons mettre \u00e0 jour ou supprimer du contenu \u00e0 tout moment.",
        },
        {
          title: "Liens vers des tiers",
          text: "Le site peut faire r\u00e9f\u00e9rence \u00e0 des sites, outils ou services tiers. Nous ne sommes pas responsables du contenu, de la disponibilit\u00e9, des politiques ou des pratiques de ces tiers.",
        },
        {
          title: "Limitation de responsabilit\u00e9",
          text: "Dans toute la mesure permise par la loi applicable, PRO-VEST Capital Management ne saurait \u00eatre tenue responsable des pertes r\u00e9sultant de l'utilisation, de l'impossibilit\u00e9 d'utiliser ou de la confiance accord\u00e9e \u00e0 ce site web ou \u00e0 son contenu.",
        },
      ],
      updatesTitle: "Modifications de ces conditions",
      updatesText: "Nous pouvons r\u00e9viser ces conditions g\u00e9n\u00e9rales de temps \u00e0 autre. La poursuite de l'utilisation du site apr\u00e8s une mise \u00e0 jour signifie que vous acceptez les conditions r\u00e9vis\u00e9es.",
    },
    banner: {
      title: "Le site est en cours de construction",
      text: "Notre site web est actuellement en cours de construction afin d'am\u00e9liorer votre exp\u00e9rience. Si vous avez des questions, n'h\u00e9sitez pas \u00e0 nous contacter par e-mail ou par t\u00e9l\u00e9phone. Merci pour votre patience.",
      callUs: "Appelez-nous",
      location: "Adresse",
    },
  },
};

export default fr;
